import React from 'react';
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {get} from 'lodash';

import './skills_passport_entry.scss';
import Bouncing from 'common/ui/Bouncing';

export default function () {
    const me = useSelector(state => state.me);
    const navigate = useNavigate();

    const render_avatar = () => {
        const avatar_class = get(me, 'avatar', '');
        return (
            <div className="spe-constellation-avatar flex-row flex-vh-center">
                <div className={`cashtivity-icon ${avatar_class}`}/>
            </div>
        );
    }

    const onClick = () => {
        navigate('/student/skills-passport');
    }

    const render_constellation = (
        <div className="spe-constellation">
            <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
                <line className="animate-dash" x1="50" y1="82" x2="15" y2="50" stroke="#AAAAAA" strokeWidth="0.5" strokeDasharray="1 1"></line>
                <line className="animate-dash" x1="15" y1="50" x2="50" y2="18" stroke="#AAAAAA" strokeWidth="0.5" strokeDasharray="1 1"></line>
                <line className="animate-dash" x1="50" y1="18" x2="85" y2="50" stroke="#AAAAAA" strokeWidth="0.5" strokeDasharray="1 1"></line>
            </svg>
            <OneStar
                tier="bronze"
            />
            <OneStar
                tier="silver"
            />
            <OneStar
                tier="gold"
            />
            <OneStar
                tier="master"
            />
            {render_avatar()}
        </div>
    );

    if (!me || me.email != "student@mindsets.com") {
        return null;
    }

    return (
        <div className="skills-passport-entry">
            <div className="spe-section">
                <div className="flex-row flex-wrap flex-gap-10">
                    {render_constellation}
                    <div className="flex-1 flex-row flex-vh-center">
                        <div className="spe-cta flex-row flex-v-center" onClick={onClick}>
                            <div className="spe-cta-title">
                                Click here to see <br /> Your Skill Constellation
                            </div>
                            <Bouncing>
                                <div className="spe-cta-icon">
                                    🚀
                                </div>
                            </Bouncing>
                        </div>
                    </div>
                </div>
            </div>

            <hr className="separator bigger"/>
        </div>
    );
}

function OneStar ({tier}) {
    const icon_url = process.env.PUBLIC_S3_ASSETS_URL
        + `/skills-passport/tier-icon/`
        + `${tier}.png`;

    return (
        <div className={`spe-constellation-star spe-constellation-star-${tier}`}>
            <div className={`spe-constellation-star-icon border-${tier} box-shadow-${tier} flex-row flex-vh-center`}>
                <img src={icon_url} />
            </div>

            <div className={`spe-constellation-star-name color-${tier}`}>
                {tier}
            </div>
        </div>
    );
}